import dayjs from 'dayjs';
import { DATE_STRING_TO_MOMENT } from 'utils/date';

export const adapterReporteUsuarios = (reporteUsuariosDatos) => {
  const reporteConFormato = reporteUsuariosDatos;
  reporteConFormato.reporteUsuario = reporteConFormato.reporteUsuario.map((reporteUsuario) => {
    return {
      ...reporteUsuario,
      fechaAltaFormat: reporteUsuario.fechaAlta
        ? dayjs(reporteUsuario.fechaAlta.toString(), DATE_STRING_TO_MOMENT)
        : '',
      ultimaModFormat: reporteUsuario.ultimaMod
        ? dayjs(reporteUsuario.ultimaMod.toString(), DATE_STRING_TO_MOMENT)
        : ''
    };
  });

  return adapterReporteUsuarios;
};
